import { sugestaoService } from '@/shared/services/sugestaoService';

export const sugestaoRepository = {
  async enviarSugestao(
    empresaId: string,
    telaId: string,
    videoId: string,
    titulo: string,
    thumbnail: string,
    canal: string,
    duracaoSegundos: number | null,
    sessionId?: string,
    clienteId?: string | null,
  ): Promise<void> {
    return sugestaoService.enviarSugestao(
      empresaId,
      telaId,
      videoId,
      titulo,
      thumbnail,
      canal,
      duracaoSegundos,
      sessionId,
      clienteId,
    );
  },
};
